import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-paraMerge",
  "use": "icon-paraMerge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-paraMerge\"><defs><style type=\"text/css\"></style></defs><path d=\"M254.9 356.4L410.5 512l-28.3 28.3-127.3 127.3-28.3-28.3L333.9 532H71.4v-40h262.5L226.6 384.7l28.3-28.3zM76 64v40h367.2v816H76v40h407.2V64H76z m693.1 292.4l28.3 28.3L690.1 492h262.5v40H690.1l107.3 107.3-28.3 28.3-127.3-127.3-28.3-28.3 155.6-155.6zM540.8 64v896H948v-40H580.8V104H948V64H540.8z\" fill=\"#ffffff\" p-id=\"2559\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol